<template>
  <div class="flag_detail">
    <div class="flag_header">
      <div class="flag_img">
        <img v-if="ysInfo.headImage" :src="ysInfo.headImage" alt="" />
        <img v-else src="@/assets/images/newYuesao/avatar.png" />
      </div>
      <div class="work_name">{{ ysInfo.workerName }}</div>
      <div class="work_star">{{ ysInfo.userTypeName }}</div>
      <div class="flag_num">获赠{{ flagList.length }}面锦旗</div>
    </div>

    <div class="flag_list">
      <div class="flag_title">
        <div class="flag_title_content">
          荣誉锦旗： {{ info.silkBannerName }}
        </div>
      </div>
      <swiper
        class="swiper"
        :options="swiperOption"
        ref="mySwiper"
        @slideChange="slideChange"
      >
        <swiper-slide v-for="(item, index) in flagList" :key="index">
          <Pnt
            :item="item"
            :timeCn="item.createTime | stampToCn"
            :workerName="item.workerName"
          />
        </swiper-slide>
      </swiper>
      <div class="flag_send">
        {{ $$dateFormat(flagList[activeIndex].createTime, 'YY.MM.DD') }}
        {{ flagList[activeIndex].nickName }}赠
      </div>
      <div
        class="comment"
        @click="goComment(flagList[activeIndex].commentId, info.workerCode)"
      >
        查看评价
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import Pnt from '@/components/evaluate/pnt.vue'
import { getYcn } from '@/components/evaluate/utils'
import 'swiper/css/swiper.css'

export default {
  props: {
    flagList: Array,
    ysInfo: Object,
    flagActiveIndex: Number
  },
  components: {
    Swiper,
    SwiperSlide,
    Pnt
  },
  filters: {
    stampToCn(timestamp) {
      return getYcn(timestamp * 1000)
    }
  },
  data() {
    return {
      swiperOption: {
        loop: false, // 无限循环
        autoplay: false,
        centeredSlides: true,
        slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量(carousel模式)。'auto'自动根据slides的宽度来设定数量
        grabCursor: true
      },
      activeIndex: 0
    }
  },
  mounted() {
    this.activeIndex = this.flagActiveIndex
    this.$nextTick(() => {
      this.flagActiveIndex
        ? this.$refs.mySwiper.$swiper.slideTo(this.flagActiveIndex, 300)
        : this.$refs.mySwiper.$swiper.slideTo(0, 300)
    })
  },
  computed: {
    info() {
      return this.flagList[this.activeIndex]
    }
  },
  methods: {
    slideChange() {
      this.$nextTick(() => {
        this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
      })
    },
    goComment(commentId, workerCode) {
      this.$router.push({
        path: '/evaluate',
        query: {
          commentId,
          workerCode,
          ht: 'look'
        }
      })
    },
    changeFlagContent(text) {
      return text.split(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/mixin.scss';

.flag_detail {
  position: fixed;
  overflow: scroll;
  top: 0;
  bottom: 0;
  background: transparent url('../../../../assets/images/flag/flag_bg@3x.png')
    no-repeat fixed;
  background-position: top center;
  background-size: cover;
  padding-bottom: rem(96px);
  background-color: gradient(180deg, #23242f 0%, #252532 100%);
  .flag_header {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    // padding-top: rem(60px);
    padding-top: rem(48px);
    .flag_img {
      img {
        width: rem(130px);
        height: rem(130px);
        border-radius: 50%;
        border: rem(5px) solid #e4b65c;
        object-fit: cover;
      }
    }

    .work_name {
      // padding: rem(15px) 0 rem(10px) 0;
      padding: rem(12px) 0 rem(10px) 0;
      text-align: center;
      font-size: rem(36px);
      color: #ffffff;
      line-height: rem(44px);
      font-weight: 600;
    }

    .work_star {
      width: rem(116px);
      height: rem(30px);
      opacity: 0.6;
      text-align: center;
      border: rem(1px) solid #ffffff;
      border-radius: rem(16px);
      font-family: PingFangSC-Regular;
      font-size: rem(22px);
      color: #ffffff;
      line-height: rem(28px);
      font-weight: 400;
    }

    .flag_num {
      position: absolute;
      top: rem(93px);
      right: 0;
      width: rem(181px);
      height: rem(54px);
      line-height: rem(54px);
      background-image: linear-gradient(270deg, #fadea8 0%, #ddac42 100%);
      border-radius: rem(27px) 0 0 rem(27px);
      font-size: rem(24px);
      color: #24242f;
      text-align: center;
    }
  }

  .flag_list {
    width: rem(690px);
    // margin: rem(60px) rem(30px) 0 rem(30px);
    margin: rem(48px) rem(30px) 0 rem(30px);
    height: rem(1013px);

    background-image: url('../../../../assets/images/flag/flag_content@3x.png');
    background-size: cover;
    .flag_title {
      width: 100%;
      padding-top: rem(138px);
      padding-bottom: rem(32px);
      height: rem(214px);
      text-align: center;
      font-size: rem(36px);
      color: #653307;
      line-height: rem(36px);
      font-weight: 600;
      .flag_title_content {
        height: rem(44px);
        width: rem(460px);
        margin-left: rem(112px);
        background-image: url('../../../../assets/images/flag_title_bg@3x.png');
        background-size: cover;
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: rem(563px);

    /deep/ .swiper-wrapper {
      transform-origin: center;
    }
  }
  .swiper-slide {
    position: relative;
    transition: 300ms;
    width: rem(480px);
    height: rem(563px);
    transform: scale(0.88);
    opacity: 0.7;
    div {
      width: 100%;
      height: 100%;
      padding-top: rem(68px);
      padding: rem(68px) rem(80px) 0 rem(80px);

      /deep/p b:nth-child(2),
      /deep/p b:nth-child(3) {
        padding-top: rem(38px);
        font-size: rem(54px);
        letter-spacing: rem(32px);
        font-family: FZY4JW--GB1-0;
      }
      /deep/ p b:nth-child(1),
      /deep/p b:nth-child(4) {
        padding-top: rem(112px);
        font-family: PingFangSC-Regular;
        justify-content: flex-start;
        font-size: rem(30px);
        letter-spacing: rem(5px);
      }
      /deep/ p b:nth-child(4) {
        padding-top: 0;
      }
      /deep/ p b:nth-child(1) {
        justify-content: flex-end;
        padding-bottom: rem(138px);
      }
    }
  }

  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    opacity: 0.9;
    transform: scale(1);
    transform-origin: center;
  }

  .flag_send {
    height: rem(37px);
    opacity: 0.95;
    font-family: PingFangSC-Regular;
    font-size: rem(26px);
    color: #8b511e;
    text-align: center;
    margin-top: rem(40px);
    margin-bottom: rem(38px);
  }

  .comment {
    width: rem(200px);
    height: rem(60px);
    line-height: rem(60px);
    background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
    border-radius: rem(39px);
    margin: 0 auto;
    font-family: PingFangSC-Regular;
    font-size: rem(30px);
    color: #ffffff;
    text-align: center;
  }
}
</style>
